import React from "react";
import { Redirect, Route } from "react-router-dom";
import Loading from "../../components/Loading/Loading";
import { useStoreState } from "../../models/RootStore";

const Authenticated = ({ component: Component, allowAfterRefresh, ...props }: any) => {
  const token = localStorage.getItem("token");
  const user = useStoreState((state) => state.users.me);
  const { isLoggedIn } = user;
  // Keep the Route mounted while session is restoring; returning null drops the
  // match out of <Switch> and the catch-all Redirect sends deep links to login.
  const waitingForSession = !!(allowAfterRefresh && token && !isLoggedIn);

  return (
    <Route
      exact={true}
      {...props}
      render={(innerProps) => {
        if (waitingForSession) {
          return <Loading />;
        }
        return isLoggedIn ? (
          <Component {...innerProps} disconnected={props.disconnected} />
        ) : (
          <Redirect to="/" />
        );
      }}
    />
  );
};

export default Authenticated;
